import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd44d1be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logout__modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logout__header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logout__title" }, "Deseja realmente sair?")
], -1))
const _hoisted_3 = { class: "logout__body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "logout__text" }, " Ao sair, você retornará para a página de login. ", -1))
const _hoisted_5 = { class: "logout__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "logout__overlay",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "btn btn--action",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, " Cancelar "),
              _createElementVNode("button", {
                class: "btn btn--action",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
              }, " Sair ")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}